import * as React from 'react';

import BicycleNumber from '@/components/elements/Icon/BicycleNumber';

import { ArrowIcon, SetNumWrapper } from './style';

interface Dokanto4TwoSetNumberProps {
  number: number;
  isUnknown?: boolean;
  size?: string | string[];
}

const Dokanto4TwoSetNumber: React.FC<Dokanto4TwoSetNumberProps> = React.memo(
  ({ number, isUnknown, size }) => {
    const splitBicycleNums = number.toString().split('').map(Number);

    return (
      <SetNumWrapper>
        <BicycleNumber
          data-testid="bicycle-num"
          bicycleNum={splitBicycleNums[0]}
          grayOut={isUnknown}
          size={size}
        >
          {isUnknown ? '?' : splitBicycleNums[0]}
        </BicycleNumber>
        <ArrowIcon data-testid="arrow-icon" />
        <BicycleNumber
          data-testid="bicycle-num"
          bicycleNum={splitBicycleNums[1]}
          grayOut={isUnknown}
          size={size}
        >
          {isUnknown ? '?' : splitBicycleNums[1]}
        </BicycleNumber>
      </SetNumWrapper>
    );
  },
);

export default Dokanto4TwoSetNumber;
